import React from 'react';
import {paths} from '../common/dictionaries/urls';
import TransportistManagement from './components/index';

export const transportistRoutes = [
  {'component': <TransportistManagement />, 'path': paths.TransportistManagement},
];
